import React from 'react'
import { styled } from 'styled-components'
import {AiOutlineArrowRight} from 'react-icons/ai'
import { Link } from 'react-router-dom'

const WhyContent = () => {
  return (
    <Container className='why-content'>
        <h2>Why Materials Research?</h2>
        <p>Explore the Future of Engineering:</p>
        <ul>
            <li>Innovate with Advance Materials</li>
            <li>Enhance Product Durability</li>
            <li>Sustainable Solutions</li>
            <li>Research-backed Progress</li>
        </ul>
        {/* Developer Memory: navigate to a blog post containing the above post list */}
        <button className='blip-btn'><Link to='/blog'>Read Post <AiOutlineArrowRight /></Link></button> 
    </Container>
  )
}

const Container = styled.section`
    background-color: var(--color-black);
    color: var(--color-white);
    padding: 10em 2em;
    h2{
        font-size: 2.2rem;
    }
    p{
        font-size: 1.1rem;
        margin: 1em 0;
    }
    ul{
        margin: 5em 0;
        list-style-type: square;
        list-style-position: inside;
        li{
            font-size: 1.1rem;
            margin: 1em 0;
        }
    }
    .blip-btn{
        a{
            color: var(--color-white);
            &:hover{
                svg{
                    transform: translateX(0.5em);
                }
                color: var(--primary-color-light);
            }
        }
    }

    /* Media Queries */
    @media only screen and (min-width: 800px){
        padding: 10em 5em;
    }
`;

export default WhyContent